export const isPositive = (value: unknown) => {
  if (typeof value === "number" && !isNaN(value)) {
    return value > 0;
  }
};
